/*
 *   File : order-history.js
 *   Author : https://evoqins.com
 *   Description : Order history modal component
 *   Integrations : NA
 *   Version : 1.0.0
*/

///Custom components
import { useEffect, useRef, useState } from 'react';
import { Icon } from '../Icon';
import { Loader } from '../Others';
import { TextButton } from '../Buttons';

import style from "../../Style/Component/portfolio.module.scss";

const ActiveSipModal = (props) => {

    const scrollRef = useRef();

    // const [activeSipData, setActiveSipData] = useState([]);

    // useEffect(() => {
    //     if (props.data && props.data.length > 0) {
    //         setActiveSipData(prev => {
    //             const existingIds = new Set(prev.map(item => item.order_id));
    //             const newItems = props.data.filter(
    //                 item => !existingIds.has(item.order_id)
    //             );
    //             return [...prev, ...newItems];
    //         });
    //     }
    // }, [props.data]);


    // handle close modal
    const _handleCloseModal = () => {
        var button = document.getElementById("active-sip-modal-close");
        button.click();
        props.handleClose();
    };

    // handle success
    const _handleSuccess = () => {
        _handleCloseModal();
        props.handleSuccess();
    };

    const _handleViewMore = () => {
        props.handleViewMore();
    }

    return (
        <div className="modal fade"
            id="active-sip-modal"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex="-1"
            aria-labelledby="OrderHistoryModalLabel"
            aria-hidden="true">
            <div className={` modal-dialog modal-dialog-centered modal-dialog-scrollable border-radius-24`}>
                <span id='active-sip-modal-close' className='d-none' data-bs-dismiss="modal"></span>
                <div className="modal-content border-radius-24 overflow-hidden border-0 pb-4">
                    <div className='modal-header border-0 pt-4 px-4 pb-3 d-flex justify-content-between align-items-center'>
                        <div className='d-flex align-items-center gap-6px'>
                            {/* <Icon icon="back-icon"
                                className="cursor-pointer"
                                size={24}
                                onClick={_handleCloseModal} /> */}
                            <h4 className='mb-0 e-text-custom-blue e-alt-font e-font-16 e-font-weight-600 line-height-22px text-center '>
                                Active Sips
                            </h4>
                        </div>
                        <Icon
                            icon="close"
                            className="d-flex e-bg-bright-gray-light border-radius-24 cursor-pointer ms-auto"
                            size="1.5rem"
                            onClick={_handleCloseModal}
                        />
                    </div>

                    <div className="modal-body  py-3 px-4" >
                        {props.loader ?
                            <Loader />
                            :
                            <>
                                <div ref={scrollRef} className="d-flex flex-column gap-3 w-100">
                                    {
                                        props.data.map((item, index) =>
                                            <div key={index} className={`${style.e_detail_data_card_wrapper} e-bg-white border-radius-12 p-4`}>
                                                <div className='d-flex justify-content-between align-items-start position-relative'>
                                                    <h6 className='mb-0 e-text-dim-black e-alt-font e-font-16 e-font-weight-600 line-height-22px'>
                                                        SIP Amount
                                                    </h6>

                                                    <p className='mb-0 e-text-blue-violet e-alt-font e-font-18 e-font-weight-600 line-height-22px'>
                                                        {item?.amount_text || '-'}
                                                    </p>

                                                </div>
                                            </div>
                                        )
                                    }


                                </div>
                                {/* {props.currentPage !== props.totalPage &&
                                    <div className='d-flex justify-content-end pt-3 pb-1'>
                                        {props.modalHistoryLoader ?
                                            <div className="loader justify-content-end">
                                                <div className="ball"></div>
                                                <div className="ball"></div>
                                                <div className="ball"></div>
                                                <div className="ball"></div>
                                            </div>
                                            :
                                            <TextButton name="View more"
                                                onClick={_handleViewMore} />
                                        }
                                    </div>
                                } */}
                            </>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ActiveSipModal;
